export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11515.a8f078ba.jpg";